// The feed card's image: its responsive `sizes`, and the local path of a bundled asset that
// next/image can optimise (null for remote URLs).

export const defaultCardImageSizes =
  '(min-width: 1750px) 24vw, (min-width: 1000px) 32vw, (min-width: 750px) 48vw, 96vw'

export const getOptimizedLocalSrc = (src) => {
  if (typeof src !== 'string') return null
  if (src.startsWith('/')) return src
  if (src.startsWith('assets/')) return `/${src}`
  return null
}
